import axios from 'axios';

import { API_URL } from '../constants/main';

let getAccessTokenSilentlyFn = null;

// Function to set the token provider (getAccessTokenSilently)
export const setAuth0TokenProvider = (fn) => {
  getAccessTokenSilentlyFn = fn;
};

axios.defaults.baseURL = API_URL;

axios.interceptors.request.use(
  async (config) => {
    if (getAccessTokenSilentlyFn) {
      try {
        const token = await getAccessTokenSilentlyFn();
        config.headers.Authorization = `Bearer ${token}`;
      } catch (error) {
        console.error('Error getting access token', error);
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 403 &&
      error.response.data.message === 'User is disabled'
    ) {
      window.location.href = '/403';
    }
    return Promise.reject(error);
  }
);
